import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SOLUTIONS } from "@/data/content";
import { SectionHeading } from "@/components/shared/SectionHeading";
import { Stagger, Item } from "@/components/shared/Reveal";
import { Icon } from "@/components/shared/Icon";

const spans = ["lg:col-span-7", "lg:col-span-5", "lg:col-span-5", "lg:col-span-7", "lg:col-span-6", "lg:col-span-6"];

export const SolutionsGrid = () => (
  <section id="solutions" data-testid="solutions-section" className="section relative bg-navy-900/50">
    <div className="wrap">
      <div className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between">
        <SectionHeading
          eyebrow="Solutions"
          title="Best practices. One integrated transportation stack."
          text="Each solution can stand alone or combine with the others into a single connected operation."
        />
        <Link to="/solutions" data-testid="solutions-view-all-link" className="btn-ghost shrink-0 self-start lg:self-auto">
          All solutions <ArrowRight className="h-4 w-4" />
        </Link>
      </div>

      <Stagger className="mt-16 grid gap-5 lg:grid-cols-12" stagger={0.07}>
        {SOLUTIONS.map((s, i) => (
          <Item key={s.slug} className={spans[i]}>
            <Link to={`/solutions/${s.slug}`} data-testid={`solution-card-${s.slug}`} className="card group flex h-full min-h-[320px] flex-col overflow-hidden">
              <div className="absolute inset-0 -z-0 opacity-70 transition-opacity duration-500 group-hover:opacity-100">
                <img src={s.image} alt="" className="h-full w-full object-cover opacity-40 transition-transform duration-700 group-hover:scale-105" loading="lazy" />
                <div className="absolute inset-0 bg-gradient-to-t from-navy-800 via-navy-800/85 to-navy-800/30" />
              </div>
              <div className="relative z-10 flex h-full flex-col p-8">
                <div className="flex items-start justify-between">
                  <span className="flex h-11 w-11 items-center justify-center rounded-xl border border-line bg-navy text-cyan-400">
                    <Icon name={s.icon} className="h-5 w-5" />
                  </span>
                  <span className="font-mono text-xs text-slate-500">0{i + 1}</span>
                </div>
                <h3 className="mt-8 text-2xl font-semibold leading-tight">{s.title}</h3>
                <p className="mt-3 max-w-md text-sm leading-relaxed text-slate-400">{s.tagline}</p>
                <div className="mt-auto flex flex-wrap gap-2 pt-8">
                  {s.stack.map((t) => (
                    <span key={t} className="rounded-full border border-line px-3 py-1 font-mono text-[10px] uppercase tracking-wider text-slate-400">{t}</span>
                  ))}
                </div>
                <div className="mt-6 flex items-center gap-2 text-sm font-semibold text-cyan-400">
                  {s.cta} <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
                </div>
              </div>
            </Link>
          </Item>
        ))}
      </Stagger>
    </div>
  </section>
);
